import "../styles/HoldingSection.css";
import { Link } from "react-router-dom";
import Pagination from "./Pagination";
import FundPlanDesignStp from "./FundPlanDesignStp";
import defaultFundIcon from "../images/Default icon.svg";

const HoldingSectionStp = ({ data }) => {
  return (
    <div>
      <div className="mb-3">
        {data?.current_holdings?.length > 0 ? (
          data?.current_holdings?.map((res) => {
            return (
              <FundPlanDesignStp
                bookmark={true}
                plus={true}
                icon1={res?.master_scheme_to?.fund_icon?.icon ? `${process.env.REACT_APP_FUND_ICON_URL}/logos/${res?.master_scheme_to?.fund_icon?.icon}.png`: defaultFundIcon}
                icon2={res?.master_scheme_from?.fund_icon?.icon ? `${process.env.REACT_APP_FUND_ICON_URL}/logos/${res?.master_scheme_from?.fund_icon?.icon}.png`: defaultFundIcon}
                title={res?.master_scheme_from?.scheme_name}
                title2={res?.master_scheme_to?.scheme_name}
                badge={res?.scheme_type}
                folioNo={res?.folio_no}
                badge2={res?.plan_type}
                price={`₹${res?.transfer_amount}`}
                datefrom={res?.stp_start_date}
                dateto={res?.stp_end_date}
                bgcolor={"primary"}
                badgecolor="green"
                badgecolor2="purple"
              />
            );
          })
        ) : (
          <p>No STP data available</p>
        )}
      </div>
    </div>
  );
};

export default HoldingSectionStp;
